"use strict";

exports.__esModule = true;
exports["default"] = {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/rc-calendar/lib/date/DateConstants.js
// module id = 1029
// module chunks = 1